module.exports = __webpack_public_path__ + "ThaiSansNeue-Regular.092b215e7fd545172900.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/corporate/css/fonts/ThaiSansNeue-Regular.ttf
// module id = ../../../../../src/assets/corporate/css/fonts/ThaiSansNeue-Regular.ttf
// module chunks = styles